import * as React from "react";
import Component from "../../AbstractComponent";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

export class ArchiveEntityPrompt extends Component {

  constructor(public props) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.archive = this.archive.bind(this);
  }

  public cancel(): void {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  public archive(): any {
    if (typeof this.props.onArchive !== "undefined") {
      this.props.onArchive.call(this);
    }
  }

  public render() {
    const {entityName, type, secondLine} = this.props;

    return (
      <Dialog
        className="dialog dialog-window has-button-padding"
        open={this.props.isOpen}
        onClose={this.cancel}
        disableBackdropClick={true}
      >
        <DialogTitle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                minHeight: "calc(24px + 2em)"
            }}>
            <h4>{this.props.title || this.trans("are-you-sure")}</h4>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="dialog-content-wrapper">
            { entityName && <p>{this.trans(entityName)}</p> }
            { secondLine && <p>{secondLine}</p> }
            { !entityName && (
            <div>
              <p>{this.trans("warning-confirm-archive1")}</p>
              <p>{this.trans("warning-confirm-archive2")}</p>
              <p>{this.trans("warning-confirm-archive3")}</p>
              <p>{this.trans("warning-confirm-archive4")}</p>
            </div>)}
            
          </div>
        </DialogContent>
        <DialogActions>
          <div className="dialog-buttons-wrapper">
            <Button
              color="primary"
              onClick={this.cancel}
            >
              {this.trans("button-cancel")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.archive}
            >
              {!!type ? this.trans(type) : this.trans("button-continue")}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}
